import { storeToRefs } from 'pinia'

import { useStoreRooms } from '@/app/store/pinia/rooms/rooms'

import { useStatusSubscribe } from '@/shared/composables/im'

export function guestViewChatPropsFn () {
  const { subscribe } = useStatusSubscribe()
  const { getGuestRoom } = storeToRefs(useStoreRooms())
  const room = getGuestRoom.value

  if (!room) {
    throw new Error('Guest room not found')
  }

  subscribe(room.pServedUser)

  return {
    room,
  }
}
